import { ArrowUpRight, Check } from "lucide-react";
import { PACKAGES, PRICING_QUOTES, SITE } from "@/data/site";
import { PACKAGES as TIDS } from "@/constants/testIds";

export default function Packages() {
  return (
    <section
      id="packages"
      data-testid={TIDS.section}
      className="py-28 md:py-40 bg-stone-50"
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="text-center max-w-3xl mx-auto mb-20 md:mb-24">
          <p className="overline mb-7">Packages · Transparent pricing</p>
          <h2 className="font-serif text-[2.8rem] sm:text-[3.6rem] md:text-[5rem] leading-[1.02] tracking-tight text-stone-900">
            Simple pricing.
            <br />
            <em className="italic font-normal text-stone-600">No surprises.</em>
          </h2>
          <p className="mt-8 font-serif italic text-stone-600 text-lg leading-relaxed max-w-xl mx-auto">
            Every package includes full digital delivery, zero travel fees inside Essex,
            and interest-free monthly payments via Klarna. Every video package includes
            full-length ceremony and speeches films — nothing is cut.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-y-16 gap-x-10">
          {PACKAGES.map((p) => (
            <div
              key={p.slug}
              data-testid={TIDS.card(p.slug)}
              className="flex flex-col"
            >
              {p.badge ? (
                <p className="font-serif italic text-[#A88F4C] mb-3 text-sm tracking-wide">
                  {p.badge}
                </p>
              ) : (
                <p className="mb-3 text-sm h-[1.25rem]" aria-hidden="true">&nbsp;</p>
              )}
              <h3 className="font-serif text-[1.8rem] md:text-[2rem] leading-[1.15] text-stone-900 min-h-[4.5rem]">
                {p.name}
              </h3>
              <div className="mt-6 mb-7">
                <p className="font-serif text-[2.6rem] text-stone-900 leading-none">
                  From <span className="kbd">{p.price}</span>
                </p>
                <p className="font-serif italic text-stone-500 mt-2 text-base">
                  or from {p.monthly}
                </p>
              </div>
              <div className="w-12 h-px bg-stone-300 mb-7" />
              <ul className="space-y-3.5 flex-1">
                {p.highlights.map((h, i) => (
                  <li
                    key={i}
                    className="flex gap-3 text-stone-700 leading-relaxed text-[0.98rem]"
                  >
                    <Check
                      className="w-4 h-4 mt-1 flex-shrink-0 text-stone-400"
                      strokeWidth={1.4}
                    />
                    <span>{h}</span>
                  </li>
                ))}
              </ul>
              <a
                href={SITE.bookingUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="link-elegant mt-8 text-base"
                data-testid={TIDS.cta(p.slug)}
              >
                Secure my date
                <ArrowUpRight className="w-4 h-4" />
              </a>
            </div>
          ))}
        </div>

        <div className="mt-20 md:mt-24 grid md:grid-cols-3 gap-x-10 gap-y-10 max-w-5xl mx-auto">
          {PRICING_QUOTES.map((q, i) => (
            <figure key={i} data-testid={`pricing-quote-${i}`} className="text-center md:text-left">
              <blockquote className="font-serif italic text-stone-700 text-[1.05rem] leading-[1.6]">
                &ldquo;{q.text}&rdquo;
              </blockquote>
              <figcaption className="mt-4 font-serif text-stone-500 text-sm">
                {q.name} ·{" "}
                <a
                  href={q.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline underline-offset-4 hover:text-stone-800 transition-colors"
                  data-testid={`pricing-quote-source-${i}`}
                >
                  verified on {q.source}
                </a>
              </figcaption>
            </figure>
          ))}
        </div>

        <p className="mt-16 text-center font-serif italic text-stone-500">
          Interest-free monthly payments available on all packages via Klarna.
        </p>
      </div>
    </section>
  );
}
